import request from '@/utils/request2'

// 列表(主数据列表)
export function loadLiveStreamingEventDetailListDataApi(data) {
  return request({
    url: 'tms-web/liveStreamingEventDetail/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportLiveStreamingEventDetailListDataApi(data) {
  return request({
    url: 'tms-web/liveStreamingEventDetail/exportByPage',
    method: 'post',
    data
  })
}

// 直播参与人员匹配零售户档案
export function matchingStoreLiveStreamingEventDetailApi(data) {
  return request({
    url: 'tms-web/liveStreamingEventDetail/matchingStore',
    method: 'post',
    data
  })
}

// 取消直播参与人员与零售户档案的匹配
export function cancelMatchingLiveStreamingEventDetailApi(data) {
  return request({
    url: 'tms-web/liveStreamingEventDetail/cancelMatching',
    method: 'post',
    data
  })
}

// 查看
export function viewLiveStreamingEventDetailApi(data) {
  return request({
    url: 'tms-web/liveStreamingEventDetail/view',
    method: 'post',
    data
  })
}
